import { Router } from 'vue-router'

/**
 * Open router in modal.
 * This guard helps to open router in modal.
 *
 * We do this operation in the beforeEach,
 * because we want to any route in the modal
 * @param router
 */
export function createModalGuard(router: Router) {
  router.beforeEach(async (to) => {
    const {
      closeModal,
      nextRoute,
      closeRouteInModal,
      setBackgroundView,
      backgroundView,
    } = useRouterModalStore()

    /**
     * Remove backgroundView when user go to different page.
     */
    if (!nextRoute && to.fullPath !== backgroundView) {
      // from=index to=issues
      setBackgroundView(undefined)
    }

    /**
     * Close route when come back!
     */
    if (nextRoute && nextRoute?.name !== to.name) {
      if (to.fullPath !== backgroundView) {
        closeModal()
        setBackgroundView(undefined)
      } else {
        // from=issues to=index
        closeRouteInModal()
      }
    }
    return true
  })
}
